import { registerCardTemplate } from "../../../common/common";
import { lazyTemplate } from "../../lazyTemplate";

// Eager metadata registration; the render component (ItemList) code-splits
// into its own tpl-item-list chunk, loaded on demand when the widget renders.
registerCardTemplate({
    id: 'item-list',
    name: "Item List",
    description: 'Show a list of items. The list can handle a large number of items, incrementally loading them as you scroll. Each item can have a title, subtitle, status and more.',
    template: lazyTemplate(() => import(/* webpackChunkName: "tpl-item-list" */ "./ItemList")),
    icon: ['fas', 'th-list'],
    complexity: 'hard',
    canDragDropFields: true,
    expectedSchema: 'dictionary-array',
});
